import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Container, Row } from 'reactstrap'
import { Modal } from "react-bootstrap";
import { IoSearchOutline } from "react-icons/io5";
import { useSelector } from 'react-redux';
import { numberWithCommas } from '../../utils/customFunction';
import {
    FaChevronLeft,
    FaChevronRight,
} from "react-icons/fa";
import { useHistory } from 'react-router-dom';
import { getAllPsx, getAllSecurities } from '../../stores/services/security.service';
import { getFundByAmc } from '../../stores/services/funds.service';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment';
import { FaCalendarAlt } from "react-icons/fa";
import { VscSplitVertical } from "react-icons/vsc";


function Money_market() {

    const history = useHistory()
    const email = sessionStorage.getItem("email") || "";
    const amc_code = sessionStorage.getItem("amc_code") || "";

    const [selectedSecurityType, setSelectedSecurityType] = useState<String>("All");
    const [coupansModal, setCoupansModal] = useState<boolean>(false)
    const [selectedCoupan, setSelectedCoupan] = useState<any>()
    const [selectedItem, setSelectedItem] = useState<any>()
    const [tempMarketArr, setTempMarketArr] = useState<any>([]);
    const [securities, setSecurities] = useState<any>([]);
    const [psxListBar, setPsxListBar] = useState<any>([]);
    const [changeView, setChangeView] = useState("Horizontal")
    const [screen, setScreen] = useState<any>()
    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
    const scrollRef = useRef<any>(null);
    const scrollRef1 = useRef<any>(null);
    // const [isAutoScrolling, setIsAutoScrolling] = useState(true);
    const [searchCompany, setSearchCompany] = useState("")
    const itemsPerPage = 10
    const [itemsToShow, setItemsToShow] = useState(10);
    const [Loading, setLoading] = useState(false);
    let [activePage, setActivePage] = useState("");
    const [pageSize, setPageSize] = useState("10");
    let [paginationArr, setPaginationArr] = useState([""]);

    const handleShowMore = () => {
        setItemsToShow(prev => prev + itemsPerPage);
    };


    useEffect(() => {
        const handleResize = () => {
            setScreen(window?.outerWidth);
            if (window?.outerWidth <= 768) {
                setChangeView("Vertical")
                setItemsToShow(10)
            }

        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const getSecurities = async () => {
        setLoading(true);
        try {
            const response = await getAllSecurities(
                email,
                activePage,
                pageSize,
                amc_code
            );

            if (response.data.data.length > 0 && response?.data?.status == 200) {
                let pageArr = paginationArr;
                let existingPageIndex = paginationArr.findIndex(
                    (x) => x === response.data.page_info.next_page_number
                );
                if (
                    existingPageIndex === -1 &&
                    response.data.data.length === 10
                ) {
                    pageArr.push(response.data.page_info.next_page_number);
                }
                setPaginationArr(pageArr);
                setSecurities(response.data.data);
                setPsxListBar(response.data.data);
                setTempMarketArr(response?.data?.data)
            } else {
                setSecurities([]);
                setPsxListBar([])
                toast.error(response.data.message);
            }
        } catch (err: any) {
            // toast.error(error.response.data.message);
            if (err.response !== undefined) {
                toast.error(err.response.data.message?.toString());
            } else {
                toast.error("Request Failed!");
            }
        }
        setLoading(false);
    };

    useEffect(() => {
        getSecurities();
    }, [activePage]);

    const handleFilter = (security = "") => {
        if (security) {
            setSecurities(tempMarketArr?.filter((item) => item?.security_type == security))
        }
        else {
            setSecurities(tempMarketArr)
        }
    }


    const getImageSrc = (symbol: string) => {
        try {
            return require(`../../assets/psxLogos/${symbol}.png`).default;
        } catch (e) {
            return require(`../../assets/psxLogos/0.png`).default;
        }
    };

    const PauseAutoTicker = () => {
        const tickerWrap = document.querySelector('.ticker-wrap');
        if (tickerWrap) {
            tickerWrap.classList.add('paused')
        }
    }

    const StartAutoTicker = () => {
        const tickerWrap = document.querySelector('.ticker-wrap');
        if (tickerWrap) {
            tickerWrap.classList.remove('paused')
        }
    }

    const handleScroll = (direction) => {
        const tickerWrap = document.querySelector('.ticker-wrap');
        if (tickerWrap) {
            tickerWrap.classList.add('paused');
            if (direction === 'left') {
                scrollRef.current.scrollLeft -= 150;
            } else {
                scrollRef.current.scrollLeft += 150;
            }
        }
    };

    const handleScrollFilter = (direction) => {
        const filterScroll = scrollRef1?.current;
        if (filterScroll) {
            if (direction === 'left') {
                scrollRef1.current.scrollTo({
                    left: scrollRef1.current.scrollLeft - 250,
                    behavior: 'smooth'
                });
                // scrollRef1.current.scrollLeft -= 150;
            } else {
                scrollRef1.current.scrollTo({
                    left: scrollRef1.current.scrollLeft + 250,
                    behavior: 'smooth'
                });
                // scrollRef1.current.scrollLeft += 150;
            }
        }
    };

    useEffect(() => {
        const ticker = document.querySelector('.ticker') as HTMLElement;
        if (ticker) {
            const totalWidth = ticker.scrollWidth;
            const speed = 50;
            const duration = totalWidth / speed;
            ticker.style.setProperty('--ticker-width', `${totalWidth}px`);
            ticker.style.setProperty('--ticker-duration', `${duration}s`);
        }
    }, [psxListBar]);


    const filterArr = [
        {
            value: "PIB",
            label: "Pakistan Investment Bonds"
        },
        {
            value: "TBILL",
            label: "Treasury Bill",
        },
        {
            value: "SUKUK",
            label: "Sukuk Certificates",
        },
        {
            value: "TFC",
            label: "Term Finance Certificates",
        },
        {
            value: "CP",
            label: "Commercial Papers",
        },
        {
            value: "TDR",
            label: "Term Deposit Receipts",
        },
        {
            value: "CDR",
            label: "Certificate Of Investment",
        },
        {
            value: "LOP",
            label: "Letter of Placement",
        },
        {
            value: "Bai Mujjal Placement",
            label: "Bai Mujjal Placement",
        },
    ]


    return (
        <div className="content">
            <ToastContainer />

            <Modal
                dialogClassName="modal90w"
                centered={true}
                show={coupansModal}
                size="xl"
                backdrop={true}
                onHide={() => {
                    setCoupansModal(false);
                }}
            >
                <div className={`modal-header p-3 `}>
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => {
                            setCoupansModal(false);
                        }}
                    >
                        <i className="tim-icons icon-simple-remove text-white" />
                    </button>
                    <h6
                        className="title title-up"
                    >
                        Coupans
                    </h6>
                </div>
                <div className="modal-body">
                    <div className="table-responsive">
                        <table
                            className="table mt-0">
                            <thead>
                                <tr>
                                    <th className='text-nowrap py-0'>
                                        <small
                                            style={{
                                                fontSize: "14px"
                                            }}
                                        >
                                            Coupon no.
                                        </small>
                                    </th>
                                    <th className='text-nowrap py-0'>
                                        <small
                                            style={{
                                                fontSize: "14px"
                                            }}
                                        >
                                            Coupon Date
                                        </small>
                                    </th>
                                    <th className='text-right text-nowrap py-0'>
                                        <small
                                            style={{
                                                fontSize: "14px"
                                            }}
                                        >
                                            Coupon Payment
                                        </small>
                                    </th>
                                    <th className='text-right text-nowrap py-0'>
                                        <small
                                            style={{
                                                fontSize: "14px"
                                            }}
                                        >
                                            Kibor Rate%
                                        </small>
                                    </th>
                                    <th className='text-right text-nowrap py-0'>
                                        <small
                                            style={{
                                                fontSize: "14px"
                                            }}
                                        >
                                            Spread Rate%
                                        </small>
                                    </th>
                                    <th className='text-right text-nowrap py-0'>
                                        <small
                                            style={{
                                                fontSize: "14px"
                                            }}
                                        >
                                            Coupon Rate%
                                        </small>
                                    </th>
                                    <th className='text-right text-nowrap py-0'>
                                        <small
                                            style={{
                                                fontSize: "14px"
                                            }}
                                        >
                                            Principal Redemption
                                        </small>
                                    </th>
                                    <th className='text-right text-nowrap py-0'>
                                        <small
                                            style={{
                                                fontSize: "14px"
                                            }}
                                        >
                                            Remaining Face Value
                                        </small>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedCoupan?.length > 0 ?
                                    selectedCoupan?.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <div className='text-primary table_heading_large'>
                                                        {index + 1}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='text-primary table_heading_large'>
                                                        {
                                                            moment(item?.coupon_date)?.format("DD-MMM-YYYY")
                                                        }
                                                    </div>
                                                </td>
                                                <td className='text-right'>
                                                    <div className='text-primary table_heading_large'>
                                                        {item.coupon_payment}
                                                    </div>
                                                    {/* <NumberFormat
                                                        thousandSeparator={true}
                                                        inputMode="numeric"
                                                        decimalScale={2}
                                                        className={'form-control text-right '}
                                                        value={item.coupon_payment}
                                                        onValueChange={(e) => {
                                                            let value = decimalValue(e.value, 2);
                                                            let tempArray = [...selectedCoupan];
                                                            tempArray[index].coupon_payment = value;
                                                            setSelectedCoupan([
                                                                ...tempArray
                                                            ])
                                                            // item.coupon_payment = value;
                                                        }}
                                                    /> */}
                                                </td>
                                                <td className='text-right'>
                                                    <div className='text-primary table_heading_large'>
                                                        {item.kibor_rate}%
                                                    </div>
                                                    {/* <NumberFormat
                                                        thousandSeparator={true}
                                                        inputMode="numeric"
                                                        decimalScale={2}
                                                        className={'form-control text-right '}
                                                        value={item.kibor_rate}
                                                        onValueChange={(e) => {
                                                            let value = decimalValue(e.value, 2);
                                                            let spreadRate = item.spread_rate == '' ? '0' : item.spread_rate;
                                                            let couponRate = +value + +spreadRate;
                                                            let tempArray = [...selectedCoupan];
                                                            tempArray[index].kibor_rate = value;
                                                            tempArray[index].coupon_rate = couponRate.toString();
                                                            tempArray[index].isKibor_empty = "";
                                                            setSelectedCoupan([
                                                                ...tempArray
                                                            ])
                                                            // item.kibor_rate = value;
                                                            // item.coupon_rate = couponRate.toString();
                                                            // item.isKibor_empty = '';
                                                        }}
                                                    /> */}
                                                </td>
                                                <td className='text-right'>
                                                    <div className='text-primary table_heading_large'>
                                                        {item.spread_rate}%
                                                    </div>
                                                    {/* <NumberFormat
                                                        thousandSeparator={true}
                                                        inputMode="numeric"
                                                        decimalScale={2}
                                                        className={'form-control text-right '}
                                                        value={item.spread_rate}
                                                        onValueChange={(e) => {
                                                            let value = decimalValue(e.value, 2);
                                                            let kiborRate = item.kibor_rate == '' ? '0' : item.kibor_rate;
                                                            let couponRate = +value + +kiborRate;
                                                            let tempArray = [...selectedCoupan];
                                                            tempArray[index].spread_rate = value;
                                                            tempArray[index].coupon_rate = couponRate.toString();
                                                            tempArray[index].isSpread_empty = "";
                                                            setSelectedCoupan([
                                                                ...tempArray
                                                            ])
                                                            // item.spread_rate = value;
                                                            // item.coupon_rate = couponRate.toString();
                                                            // item.isSpread_empty = '';
                                                        }}
                                                    /> */}
                                                </td>
                                                <td
                                                    className='text-right'>
                                                    <div className='text-primary table_heading_large'>
                                                        {
                                                            Number(numberWithCommas(item.coupon_rate))?.toFixed(2)
                                                        }%
                                                    </div>
                                                </td>
                                                <td className='text-right'>
                                                    <div className='text-primary table_heading_large'>
                                                        {item.principal_redemption}
                                                    </div>
                                                    {/* <NumberFormat
                                                        thousandSeparator={true}
                                                        inputMode="numeric"
                                                        decimalScale={2}
                                                        className={"form-control text-right"}
                                                        value={item.principal_redemption}
                                                        // onValueChange={(e) => {
                                                        //     let value = decimalValue(e.value, 2);
                                                        //     let tempArray = [...selectedCoupan];
                                                        //     tempArray[index].principal_redemption = value;
                                                        //     setSelectedCoupan([
                                                        //         ...tempArray
                                                        //     ])
                                                        // }}
                                                        onValueChange={(e) => {
                                                            let tempArray = [...selectedCoupan];
                                                            let value = decimalValue(e.value, 2);
                                                            let remainFaceValue: any;
                                                            if (index == 0) {
                                                                remainFaceValue = (+selectedItem?.face_value_per_unit - +value).toString();
                                                            } else {
                                                                remainFaceValue = (+selectedCoupan[index - 1].remaining_face_value - +value).toString();
                                                            }
                                                            tempArray.forEach((data: any, i: number) => {
                                                                if (!data.principal_redemption || +data.principal_redemption <= 0 || i == index) {
                                                                    // data.remaining_face_value = remainFaceValue
                                                                    tempArray[i].remaining_face_value = remainFaceValue;
                                                                }
                                                            })
                                                            tempArray[index].principal_redemption = value;
                                                            tempArray[index].isPrincipal_Redemp_empty = "";
                                                            setSelectedCoupan([
                                                                ...tempArray
                                                            ])
                                                            // item.principal_redemption = value;
                                                            // item.isPrincipal_Redemp_empty = '';
                                                        }}
                                                    /> */}
                                                </td>
                                                <td
                                                    className='text-right'>
                                                    <div className='text-primary table_heading_large'>
                                                        {
                                                            numberWithCommas(item.remaining_face_value)
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    ) :
                                    <p>
                                        No Data Found For Coupans
                                    </p>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
            {!Loading ?
                <Row>
                    <Col md="12">
                        <Container fluid>
                            <div
                                style={{
                                    borderRadius: "12px",
                                    borderTopRightRadius: "12px"
                                }}
                                className="card ">

                                <Col md="12" sm="12"
                                    style={{
                                        padding: "0rem 1.7rem",
                                        borderRadius: "12px",
                                        position: "relative",
                                        overflow: "hidden",
                                    }}
                                    className='border border-info bg-dark text-white py-2 ' >
                                    <FaChevronLeft
                                        onMouseEnter={() => PauseAutoTicker()}
                                        onMouseLeave={() => StartAutoTicker()}
                                        style={{
                                            position: "absolute",
                                            width: "25px",
                                            height: "25px",
                                            top: "50%",
                                            left: "1px",
                                            transform: "translate(0%, -50%)",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => {
                                            handleScroll('left')
                                        }} />
                                    <div
                                        ref={scrollRef}
                                        style={{
                                            overflowX: "auto",
                                            whiteSpace: "nowrap",
                                            scrollBehavior: "smooth",
                                        }}
                                        id='scroll_header'
                                        className="ticker-wrap"
                                    >
                                        <div
                                            style={{
                                                flexWrap: "nowrap",
                                                minWidth: "1200px",
                                                columnGap: "12px"
                                            }}
                                            className='d-flex ticker align-items-center'>
                                            {psxListBar?.map((item) => {
                                                return (
                                                    <>
                                                        <div
                                                            style={{
                                                                maxWidth: "150px",
                                                                minWidth: "150px"
                                                            }}
                                                            className='d-flex align-items-center'>
                                                            <img
                                                                src={getImageSrc(item?.symbol)}
                                                                width={50}
                                                                height={50}
                                                                style={{
                                                                    objectFit: "contain",
                                                                    objectPosition: "center"
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    lineHeight: "normal",
                                                                    width: "64%"
                                                                }}
                                                                className='d-flex flex-column ml-1 '>
                                                                <p
                                                                    style={{
                                                                        color: "rgba(255, 255, 255, 0.8)"
                                                                    }}
                                                                    data-toggle="tooltip"
                                                                    data-placement="top"
                                                                    title={item?.code}
                                                                    className='mb-0 heading_stock text-truncate'>
                                                                    {item?.code}
                                                                </p>
                                                                <small
                                                                    data-toggle="tooltip"
                                                                    data-placement="top"
                                                                    title={item?.name}
                                                                    className='text-truncate small_heading_stock'>
                                                                    {item?.name}
                                                                </small>
                                                            </div>
                                                        </div>

                                                        <div
                                                            style={{
                                                                lineHeight: "normal",
                                                                maxWidth: "110px",
                                                                minWidth: "110px"
                                                            }}
                                                            className='d-flex flex-column align-items-center'>
                                                            <p
                                                                className='mb-0 heading_stock'>
                                                                <small
                                                                    className='xSmall'
                                                                >
                                                                    Rs.
                                                                </small>
                                                                {
                                                                    item?.price?.toString()?.includes(".") ?
                                                                        item?.price?.toString()?.split(".")[0] :
                                                                        item?.price
                                                                }
                                                                <small className='xSmall'>
                                                                    .{
                                                                        item?.price?.toString()?.includes(".") ?
                                                                            item?.price?.toString()?.split(".")[1] :
                                                                            "00"
                                                                    }
                                                                </small>
                                                            </p>
                                                            {/* <small
                                                                style={{
                                                                    color: item?.change > 0 ?
                                                                        "#05bd64" :
                                                                        item?.change < 0 ?
                                                                            "#de4f45" :
                                                                            "#7ac6e1"
                                                                }}
                                                                className='small_heading_price'>
                                                                Rs {item?.change}
                                                                <span className='ml-1 percentage_val'>
                                                                    {item?.change_percent}%
                                                                </span>
                                                            </small> */}
                                                        </div>
                                                        <hr
                                                            className='border-info'
                                                            style={{
                                                                height: "70%",
                                                                width: "0px",
                                                                borderLeft: "1px solid ",
                                                            }}
                                                        >
                                                        </hr>
                                                    </>
                                                )
                                            })}

                                        </div>
                                    </div>
                                    <FaChevronRight
                                        onMouseEnter={() => PauseAutoTicker()}
                                        onMouseLeave={() => StartAutoTicker()}
                                        style={{
                                            position: "absolute",
                                            width: "25px",
                                            height: "25px",
                                            top: "50%",
                                            right: "1px",
                                            transform: "translate(0%, -50%)",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => {
                                            handleScroll('right')
                                        }} />
                                </Col>

                                <div className="card-body">
                                    <Row
                                        style={{
                                            rowGap: screen <= 1199 ? "13px" : ""
                                        }}
                                        className='d-flex justify-content-between align-items-center'>
                                        <Col xl="3" md="6" className={`d-flex order-1 ${screen <= 500 ? "flex-column justify-content-center align-items-center" : "justify-content-start"} align-items-center`}>
                                            <h5
                                                // onClick={() => history.replace("/admin/Money_market_portfolio")}
                                                className='text-primary mb-0'>Money Market</h5>
                                            <div
                                                style={{
                                                    maxWidth: "210px"
                                                }}
                                                className={`input-group ml-2 mb-0 position-relative `}>
                                                <input
                                                    style={{
                                                        borderRadius: "50px",
                                                        textAlign: "left",
                                                        padding: "4px 18px",
                                                        paddingRight: "52px"
                                                    }}
                                                    type="text"
                                                    placeholder='Search Company'
                                                    className="form-control"
                                                    onChange={(e) => {
                                                        setSearchCompany(e?.target?.value)
                                                        if (e?.target?.value) {
                                                            let temp = psxListBar?.filter((item) => {
                                                                return (
                                                                    item?.name?.toLowerCase()?.includes(e?.target?.value?.toLowerCase()) ||
                                                                    item?.code?.toLowerCase()?.includes(e?.target?.value?.toLowerCase())
                                                                );
                                                            });
                                                            setSecurities(temp)
                                                        }
                                                        else {
                                                            setSecurities(psxListBar)
                                                        }
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        right: "23px",
                                                        top: "6px",
                                                        zIndex: 45
                                                    }}
                                                    className="position-absolute"
                                                >
                                                    <IoSearchOutline fontSize={20} />
                                                </div>
                                            </div>


                                        </Col>
                                        <Col xl="7" md="6" className={`d-flex order-1 ${screen <= 500 ? "flex-column justify-content-center align-items-center" : "justify-content-start"} align-items-center`}>
                                            <div className='px-3 py-2 position-relative w-100'>
                                                <FaChevronLeft
                                                    onClick={() => handleScrollFilter("left")}
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "1px",
                                                        transform: "translate(0%, -50%)",
                                                        cursor: "pointer"
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: "12px",
                                                        flexWrap: "nowrap",
                                                        overflow: "auto"
                                                    }}
                                                    id='scroll_header'
                                                    ref={scrollRef1}
                                                >
                                                    <Button
                                                        onClick={() => {
                                                            setSelectedSecurityType("All")
                                                            handleFilter()
                                                        }}
                                                        style={{
                                                            minWidth: "120px",
                                                            width: "auto",
                                                            background: selectedSecurityType == "All" ? "" : "none"
                                                        }}
                                                        className='onHover-btn-effect border border-info rounded-pill'
                                                        size="sm"
                                                        color="primary"
                                                        outline
                                                    >
                                                        All
                                                    </Button>
                                                    {filterArr?.map((item, index) => (
                                                        <div key={index}>
                                                            <Button
                                                                onClick={() => {
                                                                    setSelectedSecurityType(item?.value)
                                                                    handleFilter(item?.value)
                                                                }}
                                                                style={{
                                                                    minWidth: "120px",
                                                                    width: index == filterArr?.length - 1 ? "max-content" : "auto",
                                                                    background: selectedSecurityType == item?.value ? "" : "none"
                                                                }}
                                                                className='onHover-btn-effect border border-info rounded-pill'
                                                                size="sm"
                                                                color="primary"
                                                                outline
                                                            >
                                                                {item?.value}
                                                            </Button>
                                                        </div>
                                                    ))
                                                    }

                                                </div>
                                                <FaChevronRight
                                                    onClick={() => handleScrollFilter("right")}
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        right: "1px",
                                                        transform: "translate(0%, -50%)",
                                                        cursor: "pointer"
                                                    }}
                                                />
                                            </div>
                                        </Col>

                                        <Col
                                            xl="2"
                                            md="6"
                                            className={`d-flex order-${screen <= 1199 ? "2" : "3"} justify-content-${screen <= 500 ? "center" : "end"}`}
                                        >
                                            <div className='mr-1'>
                                                <VscSplitVertical
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title={"Table View"}
                                                    onClick={() => {
                                                        setChangeView("Horizontal")
                                                        setItemsToShow(10)
                                                    }}
                                                    className={`${changeView == "Horizontal" ? "text-info" : ""}`}
                                                    style={{
                                                        cursor: "pointer",
                                                        height: "26px",
                                                        width: "26px",

                                                    }}
                                                />
                                                <VscSplitVertical
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title={"Card View"}
                                                    className={`${changeView == "Vertical" ? "text-info" : ""}`}
                                                    onClick={() => {
                                                        setChangeView("Vertical")
                                                        setItemsToShow(10)
                                                    }}
                                                    style={{
                                                        cursor: "pointer",
                                                        height: "26px",
                                                        width: "26px",
                                                        marginBottom: "5px",
                                                        marginLeft: "2px",
                                                        transform: "rotate(90deg)"
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    {changeView == "Horizontal" ?
                                        <>
                                            <div className="table-responsive">
                                                <table
                                                    style={{
                                                        minWidth: "1200px"
                                                    }}
                                                    className="table mt-0">
                                                    <tbody>
                                                        {securities?.map((item, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td
                                                                        style={{
                                                                            width: "120px",
                                                                            maxWidth: "180px"
                                                                        }}
                                                                        className='border-y'>
                                                                        <div
                                                                            style={{ lineHeight: "normal" }}
                                                                            className='d-flex align-items-center w-75'>
                                                                            <img
                                                                                className='mr-2'
                                                                                src={getImageSrc(item?.symbol)}
                                                                                width={50}
                                                                                height={50}
                                                                                style={{
                                                                                    objectFit: "contain",
                                                                                    objectPosition: "center"
                                                                                }}
                                                                            />
                                                                            <div
                                                                                style={{
                                                                                    width: "inherit"
                                                                                }}
                                                                                className='d-flex flex-column'
                                                                            >
                                                                                <small
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Security
                                                                                </small>
                                                                                <p
                                                                                    style={{
                                                                                        fontWeight: 600
                                                                                    }}
                                                                                    data-toggle="tooltip"
                                                                                    data-placement="top"
                                                                                    title={item?.code}
                                                                                    className='mb-0 text-primary table_heading_large text-truncate'>
                                                                                    {item?.code}
                                                                                </p>
                                                                                <small
                                                                                    data-toggle="tooltip"
                                                                                    data-placement="top"
                                                                                    title={item?.name}
                                                                                    className='text-info small_heading text-truncate'>
                                                                                    {item?.name}
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td
                                                                        className='border-y'>
                                                                        <Row
                                                                            className='align-items-center'
                                                                        // style={{
                                                                        //     gap: "12px"
                                                                        // }}
                                                                        // className={`d-flex justify-content-around ${screen <= 1024 ? "flex-column" : ""}`}
                                                                        >
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center'
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Issue Date
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    {moment(item?.issue_date)?.format("DD-MMM-YYYY")}
                                                                                </p>
                                                                            </Col>
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center'
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Days Passed
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    {
                                                                                        numberWithCommas(moment().diff(moment(item?.issue_date), 'days') || 0)
                                                                                    }
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                    <td
                                                                        className='border-y'>
                                                                        <Row
                                                                            className='align-items-center'
                                                                        // style={{
                                                                        //     gap: "12px"
                                                                        // }}
                                                                        // className={`d-flex justify-content-around ${screen <= 1024 ? "flex-column" : ""}`}
                                                                        >
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center'
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Maturity Date
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    {moment(item?.maturity_date)?.format("DD-MMM-YYYY")}
                                                                                </p>
                                                                            </Col>
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center'
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Days Remaining
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    {
                                                                                        numberWithCommas(moment(item?.maturity_date).diff(moment(), 'days') || 0)
                                                                                    }
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                    <td
                                                                        className='border-y'>
                                                                        <Row
                                                                            className='align-items-center'
                                                                        // style={{
                                                                        //     gap: "12px"
                                                                        // }}
                                                                        // className={`d-flex justify-content-around ${screen <= 1024 ? "flex-column" : ""}`}
                                                                        >
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal", minWidth: "64px" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center d-flex align-items-center'
                                                                                    style={{ opacity: "0.4" }}>
                                                                                    Coupons
                                                                                    {item?.no_of_coupons !== 0 &&
                                                                                        <FaCalendarAlt
                                                                                            onClick={() => {
                                                                                                setCoupansModal(true)
                                                                                                let coupansArr = JSON?.parse(item?.coupons || "[]")
                                                                                                setSelectedCoupan(coupansArr)
                                                                                                setSelectedItem(item)
                                                                                            }}
                                                                                            data-toggle="tooltip"
                                                                                            data-placement="top"
                                                                                            title="Coupans Schedule"
                                                                                            className='ml-1'
                                                                                            style={{
                                                                                                cursor: "pointer"
                                                                                            }}
                                                                                        />}

                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    {
                                                                                        numberWithCommas(item?.no_of_coupons || 0)
                                                                                    }
                                                                                </p>
                                                                            </Col>
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center'
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    CPN/Year
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    {
                                                                                        item?.coupon_payment_per_year
                                                                                    }
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            maxWidth: "150px"
                                                                        }}
                                                                        className='border-y'>
                                                                        <Row
                                                                            className='align-items-center'
                                                                        // style={{
                                                                        //     gap: "12px"
                                                                        // }}
                                                                        // className={`d-flex justify-content-around ${screen <= 1024 ? "flex-column" : ""}`}
                                                                        >
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center'
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Face Value
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    <small
                                                                                        className='xSmall'
                                                                                    >
                                                                                        Rs.
                                                                                    </small>

                                                                                    {
                                                                                        numberWithCommas(item?.face_value?.toString()?.includes(".") ?
                                                                                            item?.face_value?.toString()?.split(".")[1] :
                                                                                            item?.face_value || 0)
                                                                                    }
                                                                                    <small className='xSmall'>
                                                                                        .{
                                                                                            item?.face_value?.toString()?.includes(".") ?
                                                                                                item?.face_value?.toString()?.split(".")[1] :
                                                                                                "00"
                                                                                        }
                                                                                    </small>
                                                                                </p>
                                                                            </Col>
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center'
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Face Value/Unit
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large  w-100 text-center'>
                                                                                    <small
                                                                                        className='xSmall'
                                                                                    >
                                                                                        Rs.
                                                                                    </small>

                                                                                    {
                                                                                        numberWithCommas(item?.face_value_per_unit?.toString()?.includes(".") ?
                                                                                            item?.face_value_per_unit?.toString()?.split(".")[1] :
                                                                                            item?.face_value_per_unit || 0)
                                                                                    }
                                                                                    <small className='xSmall'>
                                                                                        .{
                                                                                            item?.face_value_per_unit?.toString()?.includes(".") ?
                                                                                                item?.face_value_per_unit?.toString()?.split(".")[1] :
                                                                                                "00"
                                                                                        }
                                                                                    </small>
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                    <td
                                                                        className='border-y'>
                                                                        <Row
                                                                            className='align-items-center'
                                                                        // className='d-flex justify-content-around'
                                                                        >
                                                                            <Col
                                                                                xl={12}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Price
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    <small
                                                                                        className='xSmall'
                                                                                    >
                                                                                        Rs.
                                                                                    </small>

                                                                                    {
                                                                                        numberWithCommas(item?.price?.toString()?.includes(".") ?
                                                                                            item?.price?.toString()?.split(".")[1] :
                                                                                            item?.price || 0)
                                                                                    }
                                                                                    <small className='xSmall'>
                                                                                        .{
                                                                                            item?.price?.toString()?.includes(".") ?
                                                                                                item?.price?.toString()?.split(".")[1] :
                                                                                                "00"
                                                                                        }
                                                                                    </small>
                                                                                </p>
                                                                            </Col>

                                                                        </Row>
                                                                    </td>

                                                                    <td
                                                                        className='border-y'>
                                                                        <Row
                                                                            className='align-items-center'
                                                                        // style={{
                                                                        //     gap: "12px"
                                                                        // }}
                                                                        // className={`d-flex justify-content-around ${screen <= 1024 ? "flex-column" : ""}`}
                                                                        >
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center'
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Kiber Rate
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    {
                                                                                        item?.kibor_rate
                                                                                    }
                                                                                    <small className='xSmall'>
                                                                                        %
                                                                                    </small>
                                                                                </p>
                                                                            </Col>
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center'
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Kibor Rate Benchmark
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    {
                                                                                        item?.kibor_rate_benchmark
                                                                                    }
                                                                                    <small className='xSmall'>
                                                                                        %
                                                                                    </small>
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                    <td
                                                                        className='border-y'>
                                                                        <Row
                                                                            className='align-items-center'
                                                                        // style={{
                                                                        //     gap: "12px"
                                                                        // }}
                                                                        // className={`d-flex justify-content-around ${screen <= 1024 ? "flex-column" : ""}`}
                                                                        >
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center'
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Yield Percentage
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    {
                                                                                        item?.yield_percentage
                                                                                    }
                                                                                    <small className='xSmall'>
                                                                                        %
                                                                                    </small>
                                                                                </p>
                                                                            </Col>
                                                                            <Col
                                                                                xl={6}
                                                                                lg={12}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                style={{ lineHeight: "normal" }}
                                                                                className='d-flex flex-column align-items-center'>
                                                                                <small
                                                                                    className='text-center'
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                >
                                                                                    Spread Rate
                                                                                </small>
                                                                                <p
                                                                                    style={{ fontWeight: 600 }}
                                                                                    className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                                                    {
                                                                                        item?.spread_rate
                                                                                    }
                                                                                    <small className='xSmall'>
                                                                                        %
                                                                                    </small>
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className='d-flex justify-content-center'>
                                                {/* PREVIOUS BUTTON */}
                                                {activePage !== paginationArr[0] ? (
                                                    <Button
                                                        size="md"
                                                        id='hoverNoEffect'
                                                        style={{
                                                            background: "none"
                                                        }}
                                                        className=' border border-primary'
                                                        onClick={() => {
                                                            let pageArr = paginationArr;
                                                            let index = pageArr.findIndex((x) => x === activePage);
                                                            if (index !== -1) {
                                                                setActivePage(paginationArr[index - 1]);
                                                            }
                                                        }}
                                                    >
                                                        Previous
                                                    </Button>
                                                ) : (
                                                    ""
                                                )}
                                                {/* NEXT BUTTON */}
                                                {activePage !== paginationArr[paginationArr.length - 1] ? (
                                                    <Button
                                                        size="md"
                                                        id='hoverNoEffect'
                                                        style={{
                                                            background: "none"
                                                        }}
                                                        className=' border border-primary'
                                                        onClick={() => {
                                                            let pageArr = paginationArr;
                                                            let index = pageArr.findIndex((x) => x === activePage);
                                                            if (index !== -1) {
                                                                setActivePage(paginationArr[index + 1]);
                                                            }
                                                        }}
                                                    >
                                                        Next
                                                    </Button>

                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </>
                                        :
                                        <>
                                            <Col
                                                style={{
                                                    borderTop: "1px solid"
                                                }}
                                                className='col-12'>
                                                <Row className='pt-3'>
                                                    {securities?.slice(0, itemsToShow)?.map((item, index) => {
                                                        return (
                                                            <Col lg="4" xl="2" md="4" className={`mb-5 ${screen <= 500 ? "pb-3 border-bottom" : ""}`}>
                                                                <div
                                                                    style={{
                                                                        rowGap: "10px",
                                                                        borderRadius: "15px",
                                                                        border: "1px solid #1d8cf8 "
                                                                    }}
                                                                    className='d-flex flex-column align-items-center text-center py-2 shadow'>
                                                                    <img
                                                                        src={getImageSrc(item?.symbol)}
                                                                        width={50}
                                                                        height={50}
                                                                        style={{
                                                                            objectFit: "contain",
                                                                            objectPosition: "center"
                                                                        }}
                                                                    />
                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column w-100'>
                                                                        <p
                                                                            style={{ fontWeight: 600 }}
                                                                            data-toggle="tooltip" data-placement="top" title={item?.code}
                                                                            className='mb-0 text-primary table_heading_large text-truncate'>{item?.code}</p>
                                                                        <small
                                                                            style={{ whiteSpace: "break-spaces" }}
                                                                            data-toggle="tooltip" data-placement="top" title={item?.name}
                                                                            className='text-info small_heading text-truncate'>{item?.name}</small>
                                                                    </div>


                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            Issue Date
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 table_heading_large text-primary'>
                                                                            {moment(item?.issue_date)?.format("DD-MMM-YYYY")}
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            Days Passed
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 table_heading_large text-primary'>
                                                                            {
                                                                                numberWithCommas(moment().diff(moment(item?.issue_date), 'days') || 0)
                                                                            }
                                                                        </p>
                                                                    </div>

                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            Maturity Date
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 table_heading_large text-primary'>
                                                                            {moment(item?.maturity_date)?.format("DD-MMM-YYYY")}
                                                                        </p>
                                                                    </div>

                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            Days Remaining
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 table_heading_large text-primary'>
                                                                            {
                                                                                numberWithCommas(moment(item?.maturity_date).diff(moment(), 'days') || 0)
                                                                            }
                                                                        </p>
                                                                    </div>

                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme} text-center d-flex align-items-center`}>
                                                                            Coupons
                                                                            {item?.no_of_coupons !== 0 &&
                                                                                <FaCalendarAlt
                                                                                    onClick={() => {
                                                                                        setCoupansModal(true)
                                                                                        let coupansArr = JSON?.parse(item?.coupons || "[]")
                                                                                        setSelectedCoupan(coupansArr)
                                                                                        setSelectedItem(item)
                                                                                    }}
                                                                                    data-toggle="tooltip" data-placement="top" title="Coupans Schedule"
                                                                                    className='ml-1'
                                                                                    style={{
                                                                                        cursor: "pointer"
                                                                                    }}
                                                                                />}
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 table_heading_large text-primary'>
                                                                            {
                                                                                numberWithCommas(item?.no_of_coupons || 0)
                                                                            }
                                                                        </p>
                                                                    </div>

                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            CPN/Year
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 table_heading_large text-primary'>
                                                                            {
                                                                                item?.coupon_payment_per_year
                                                                            }
                                                                        </p>
                                                                    </div>


                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            Face Value
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 text-primary table_heading_large'>
                                                                            <small
                                                                                className='xSmall'
                                                                            >
                                                                                Rs.
                                                                            </small>
                                                                            {
                                                                                numberWithCommas(item?.face_value?.toString()?.includes(".") ?
                                                                                    item?.face_value?.toString()?.split(".")[1] :
                                                                                    item?.face_value || 0)
                                                                            }
                                                                            <small className='xSmall'>
                                                                                .{
                                                                                    item?.face_value?.toString()?.includes(".") ?
                                                                                        item?.face_value?.toString()?.split(".")[1] :
                                                                                        "00"
                                                                                }
                                                                            </small></p>
                                                                    </div>

                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            Face Value/Unit
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 text-primary table_heading_large'>
                                                                            <small
                                                                                className='xSmall'
                                                                            >
                                                                                Rs.
                                                                            </small>
                                                                            {
                                                                                numberWithCommas(item?.face_value_per_unit?.toString()?.includes(".") ?
                                                                                    item?.face_value_per_unit?.toString()?.split(".")[1] :
                                                                                    item?.face_value_per_unit || 0)
                                                                            }
                                                                            <small className='xSmall'>
                                                                                .{
                                                                                    item?.face_value_per_unit?.toString()?.includes(".") ?
                                                                                        item?.face_value_per_unit?.toString()?.split(".")[1] :
                                                                                        "00"
                                                                                }
                                                                            </small></p>
                                                                    </div>

                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            Price
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 text-primary table_heading_large'>
                                                                            <small
                                                                                className='xSmall'
                                                                            >
                                                                                Rs.
                                                                            </small>
                                                                            {
                                                                                numberWithCommas(item?.price?.toString()?.includes(".") ?
                                                                                    item?.price?.toString()?.split(".")[1] :
                                                                                    item?.price || 0)
                                                                            }
                                                                            <small className='xSmall'>
                                                                                .{
                                                                                    item?.price?.toString()?.includes(".") ?
                                                                                        item?.price?.toString()?.split(".")[1] :
                                                                                        "00"
                                                                                }
                                                                            </small></p>
                                                                    </div>

                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            Kiber Rate
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 table_heading_large text-primary'>
                                                                            {
                                                                                item?.kibor_rate
                                                                            }
                                                                            <small className='xSmall'>
                                                                                %
                                                                            </small>
                                                                        </p>
                                                                    </div>

                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            Kibor Rate Benchmark
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 table_heading_large text-primary'>
                                                                            {
                                                                                item?.kibor_rate_benchmark
                                                                            }
                                                                            <small className='xSmall'>
                                                                                %
                                                                            </small>
                                                                        </p>
                                                                    </div>

                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            Yield Percentage
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 table_heading_large text-primary'>
                                                                            {
                                                                                item?.yield_percentage
                                                                            }
                                                                            <small className='xSmall'>
                                                                                %
                                                                            </small>
                                                                        </p>
                                                                    </div>

                                                                    <div
                                                                        style={{ lineHeight: "normal" }}
                                                                        className='d-flex flex-column align-items-center w-100'>
                                                                        <small
                                                                            style={{ opacity: "0.4" }}
                                                                            className={`smallTagColor-${theme}`}>
                                                                            Spread Rate
                                                                        </small>
                                                                        <p
                                                                            style={{
                                                                                fontWeight: 600,
                                                                                whiteSpace: "break-spaces"
                                                                            }}
                                                                            className='mb-0 table_heading_large text-primary'>
                                                                            {
                                                                                item?.spread_rate
                                                                            }
                                                                            <small className='xSmall'>
                                                                                %
                                                                            </small>
                                                                        </p>
                                                                    </div>

                                                                </div>
                                                            </Col>
                                                        )
                                                    })}
                                                </Row>
                                                <div className='d-flex justify-content-center'>
                                                    {itemsToShow < securities.length && (
                                                        <div className='d-flex justify-content-center my-2'>
                                                            <Button
                                                                size="md" color="primary"
                                                                onClick={handleShowMore}
                                                            >
                                                                Show More
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                            <div className='d-flex justify-content-center'>
                                                {/* PREVIOUS BUTTON */}
                                                {activePage !== paginationArr[0] ? (
                                                    <Button
                                                        size="md"
                                                        id='hoverNoEffect'
                                                        style={{
                                                            background: "none"
                                                        }}
                                                        className=' border border-primary'
                                                        onClick={() => {
                                                            let pageArr = paginationArr;
                                                            let index = pageArr.findIndex((x) => x === activePage);
                                                            if (index !== -1) {
                                                                setActivePage(paginationArr[index - 1]);
                                                            }
                                                        }}
                                                    >
                                                        Previous
                                                    </Button>
                                                ) : (
                                                    ""
                                                )}
                                                {/* NEXT BUTTON */}
                                                {activePage !== paginationArr[paginationArr.length - 1] ? (
                                                    <Button
                                                        id='hoverNoEffect'
                                                        size="md"
                                                        style={{
                                                            background: "none"
                                                        }}
                                                        outline
                                                        className=' border border-primary'
                                                        onClick={() => {
                                                            let pageArr = paginationArr;
                                                            let index = pageArr.findIndex((x) => x === activePage);
                                                            if (index !== -1) {
                                                                setActivePage(paginationArr[index + 1]);
                                                            }
                                                        }}
                                                    >
                                                        Next
                                                    </Button>

                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </Container>
                    </Col>
                </Row> :
                <div className="d-flex justify-content-center my-3 w-100">
                    <i
                        className="fa fa-spinner fa-spin fa-3x"
                        aria-hidden="true"
                    ></i>
                </div>
            }
        </div >
    )
}

export default Money_market